export default __webpack_public_path__ + "static/media/gapd.befddae9.png";